import { createAction } from "@reduxjs/toolkit";
import {
  IInformationTypeAccess,
  IInformationTypePermissionSet,
} from "../../models/informationType";
import { InformationTypeTypes } from "./types";

export const availableFetchRequest = createAction<
  void,
  InformationTypeTypes.AVAILABLE_FETCH_REQUEST
>(InformationTypeTypes.AVAILABLE_FETCH_REQUEST);

export const availableFetchSuccess = createAction<
  IInformationTypeAccess[],
  InformationTypeTypes.AVAILABLE_FETCH_SUCCESS
>(InformationTypeTypes.AVAILABLE_FETCH_SUCCESS);

export const availableFetchError = createAction<
  void,
  InformationTypeTypes.AVAILABLE_FETCH_ERROR
>(InformationTypeTypes.AVAILABLE_FETCH_ERROR);

export const permissionsFetchRequest = createAction<
  void,
  InformationTypeTypes.PERMISSIONS_FETCH_REQUEST
>(InformationTypeTypes.PERMISSIONS_FETCH_REQUEST);

export const permissionsFetchSuccess = createAction<
  IInformationTypePermissionSet,
  InformationTypeTypes.PERMISSIONS_FETCH_SUCCESS
>(InformationTypeTypes.PERMISSIONS_FETCH_SUCCESS);

export const permissionsFetchError = createAction<
  void,
  InformationTypeTypes.PERMISSIONS_FETCH_ERROR
>(InformationTypeTypes.PERMISSIONS_FETCH_ERROR);

export const permissionsReset = createAction<
  void,
  InformationTypeTypes.PERMISSIONS_RESET
>(InformationTypeTypes.PERMISSIONS_RESET);
